import { Chip, SvgIcon } from '@mui/material';
import { FaceSmile, FaceFrown, FaceNeutral } from '../../assets/images';
export default function NpsChip(props) {
    var rating = props.rating;
    var SmileyIcon = FaceSmile;
    var label = 'Promoter';
    var color = 'success';
    if (rating <= 6) {
        SmileyIcon = FaceFrown;
        label = 'Detractor';
        color = 'error';
    }
    else if (rating <= 8) {
        SmileyIcon = FaceNeutral;
        label = 'Passive';
        color = 'secondary';
    }
    return /*#__PURE__*/ React.createElement(Chip, {
        shape: "rounded",
        label: label,
        color: color,
        size: "small",
        icon: /*#__PURE__*/ React.createElement(SvgIcon, {
            fontSize: "inherit"
        }, " ", /*#__PURE__*/ React.createElement(SmileyIcon, null), " ")
    });
}
